import { createContext } from "react";
import { ServiceContextProps } from "@/types/services.types";

export const ServiceContext = createContext<ServiceContextProps | undefined>(
  undefined
);
